// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/services-img.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Brand colors */
:root {
  --ace-dark: #0a3c2f;
  --ace-green: #007c4f;
  --ace-yellow: #ffd600;
  --ink: #0f172a;
  --muted: #334155;
  --card: rgba(255, 255, 255, 0.93);
}

/* === Page Background === */
.services-page {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}

/* Hero overlay for readability */
.services-hero {
  width: 100%;
  flex: 1 1;
  padding: 30px 0 70px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.78) 0%,
    rgba(255, 255, 255, 0.84) 45%,
    rgba(255, 255, 255, 0.88) 100%
  );
}

/* Main content section */
.services-content {
  max-width: 1200px;
  width: 92%;
  margin: 110px auto 0 auto;
  text-align: center;
  border-radius: 18px;
  padding: 54px 46px;
}

/* Header text */
.services-kicker {
  margin: 0 0 8px;
  font-weight: 800;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: #000;
  font-size: 12px;
}

.services-title {
  font-size: 2.75rem;
  font-weight: 900;
  margin: 0 0 12px;
  line-height: 1.1;
}

.title-green {
  color: var(--ace-dark);
}

.title-yellow {
  color: var(--ace-green);
  position: relative;
}

.services-underline {
  width: 150px;
  height: 6px;
  margin: 16px auto 18px;
  border-radius: 999px;
  background: linear-gradient(90deg, var(--ace-green), var(--ace-yellow));
}

.services-subtitle {
  font-size: 1.05rem;
  color: #000;
  margin: 0 auto 46px;
  max-width: 820px;
  line-height: 1.7;
}

/* === Grid === */
.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 22px;
}

/* === Cards === */
.service-card {
  background: var(--card);
  border-radius: 16px;
  padding: 26px 24px;
  text-align: left;
  box-shadow: 0 12px 26px rgba(0, 0, 0, 0.12);

  /* ✅ required */
  border-left: 8px solid var(--ace-dark);

  transition: transform 0.22s ease, box-shadow 0.22s ease;
}

.service-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 16px 32px rgba(0, 0, 0, 0.16);
}

.service-card-title {
  margin: 0 0 10px;
  font-size: 1.25rem;
  font-weight: 900;
  color: #007d4f;
}

.service-card-desc {
  margin: 0 0 18px;
  font-size: 0.98rem;
  color: #0b1220;
  line-height: 1.65;
}

/* Buttons */
.service-card-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

/* Primary (green) */
.btn-primary {
  background: var(--ace-green);
  color: #fff;
  border: none;
  padding: 11px 16px;
  border-radius: 12px;
  font-weight: 800;
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease, opacity 0.18s ease;
}

.btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 12px 22px rgba(0, 124, 79, 0.22);
}

/* Secondary (yellow) */
.btn-secondary {
  background: var(--ace-yellow);
  color: #111827;
  border: none;
  padding: 11px 16px;
  border-radius: 12px;
  font-weight: 900;
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease, opacity 0.18s ease;
}

.btn-secondary:hover {
  transform: translateY(-1px);
  box-shadow: 0 12px 22px rgba(255, 214, 0, 0.22);
}

/* Bottom note */
.services-bottom-note {
  margin-top: 36px;
  font-weight: 700;
  color: rgba(15, 23, 42, 0.85);
}

.link-btn {
  background: transparent;
  border: none;
  color: var(--ace-green);
  font-weight: 900;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
}

/* Responsive */
@media (max-width: 992px) {
  .services-content {
    padding: 40px 22px;
    margin-top: 95px;
    width: 94%;
  }

  .services-title {
    font-size: 2.2rem;
  }

  .services-subtitle {
    font-size: 1rem;
    margin-bottom: 34px;
  }
}

@media (max-width: 768px) {
  .services-content {
    margin-top: 85px;
  }

  .services-title {
    font-size: 1.85rem;
  }

  .services-grid {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Services/Services.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,4BAA4B;AAC5B;EACE,yDAAyD;EACzD,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,SAAO;EACP,oBAAoB;EACpB;;;;;GAKC;AACH;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,uEAAuE;AACzE;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;;EAE3C,eAAe;EACf,sCAAsC;;EAEtC,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,2EAA2E;AAC7E;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,uBAAuB;AACvB;EACE,6BAA6B;EAC7B,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,2EAA2E;AAC7E;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,UAAU;AACZ;;AAEA,eAAe;AACf;EACE;IACE,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Brand colors */\n:root {\n  --ace-dark: #0a3c2f;\n  --ace-green: #007c4f;\n  --ace-yellow: #ffd600;\n  --ink: #0f172a;\n  --muted: #334155;\n  --card: rgba(255, 255, 255, 0.93);\n}\n\n/* === Page Background === */\n.services-page {\n  background-image: url(\"../../../public/services-img.jpg\");\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  overflow-x: hidden;\n}\n\n/* Hero overlay for readability */\n.services-hero {\n  width: 100%;\n  flex: 1;\n  padding: 30px 0 70px;\n  background: linear-gradient(\n    180deg,\n    rgba(255, 255, 255, 0.78) 0%,\n    rgba(255, 255, 255, 0.84) 45%,\n    rgba(255, 255, 255, 0.88) 100%\n  );\n}\n\n/* Main content section */\n.services-content {\n  max-width: 1200px;\n  width: 92%;\n  margin: 110px auto 0 auto;\n  text-align: center;\n  border-radius: 18px;\n  padding: 54px 46px;\n}\n\n/* Header text */\n.services-kicker {\n  margin: 0 0 8px;\n  font-weight: 800;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n  color: #000;\n  font-size: 12px;\n}\n\n.services-title {\n  font-size: 2.75rem;\n  font-weight: 900;\n  margin: 0 0 12px;\n  line-height: 1.1;\n}\n\n.title-green {\n  color: var(--ace-dark);\n}\n\n.title-yellow {\n  color: var(--ace-green);\n  position: relative;\n}\n\n.services-underline {\n  width: 150px;\n  height: 6px;\n  margin: 16px auto 18px;\n  border-radius: 999px;\n  background: linear-gradient(90deg, var(--ace-green), var(--ace-yellow));\n}\n\n.services-subtitle {\n  font-size: 1.05rem;\n  color: #000;\n  margin: 0 auto 46px;\n  max-width: 820px;\n  line-height: 1.7;\n}\n\n/* === Grid === */\n.services-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap: 22px;\n}\n\n/* === Cards === */\n.service-card {\n  background: var(--card);\n  border-radius: 16px;\n  padding: 26px 24px;\n  text-align: left;\n  box-shadow: 0 12px 26px rgba(0, 0, 0, 0.12);\n\n  /* ✅ required */\n  border-left: 8px solid var(--ace-dark);\n\n  transition: transform 0.22s ease, box-shadow 0.22s ease;\n}\n\n.service-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 16px 32px rgba(0, 0, 0, 0.16);\n}\n\n.service-card-title {\n  margin: 0 0 10px;\n  font-size: 1.25rem;\n  font-weight: 900;\n  color: #007d4f;\n}\n\n.service-card-desc {\n  margin: 0 0 18px;\n  font-size: 0.98rem;\n  color: #0b1220;\n  line-height: 1.65;\n}\n\n/* Buttons */\n.service-card-actions {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n/* Primary (green) */\n.btn-primary {\n  background: var(--ace-green);\n  color: #fff;\n  border: none;\n  padding: 11px 16px;\n  border-radius: 12px;\n  font-weight: 800;\n  cursor: pointer;\n  transition: transform 0.18s ease, box-shadow 0.18s ease, opacity 0.18s ease;\n}\n\n.btn-primary:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 12px 22px rgba(0, 124, 79, 0.22);\n}\n\n/* Secondary (yellow) */\n.btn-secondary {\n  background: var(--ace-yellow);\n  color: #111827;\n  border: none;\n  padding: 11px 16px;\n  border-radius: 12px;\n  font-weight: 900;\n  cursor: pointer;\n  transition: transform 0.18s ease, box-shadow 0.18s ease, opacity 0.18s ease;\n}\n\n.btn-secondary:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 12px 22px rgba(255, 214, 0, 0.22);\n}\n\n/* Bottom note */\n.services-bottom-note {\n  margin-top: 36px;\n  font-weight: 700;\n  color: rgba(15, 23, 42, 0.85);\n}\n\n.link-btn {\n  background: transparent;\n  border: none;\n  color: var(--ace-green);\n  font-weight: 900;\n  cursor: pointer;\n  text-decoration: underline;\n  padding: 0;\n}\n\n/* Responsive */\n@media (max-width: 992px) {\n  .services-content {\n    padding: 40px 22px;\n    margin-top: 95px;\n    width: 94%;\n  }\n\n  .services-title {\n    font-size: 2.2rem;\n  }\n\n  .services-subtitle {\n    font-size: 1rem;\n    margin-bottom: 34px;\n  }\n}\n\n@media (max-width: 768px) {\n  .services-content {\n    margin-top: 85px;\n  }\n\n  .services-title {\n    font-size: 1.85rem;\n  }\n\n  .services-grid {\n    grid-template-columns: 1fr;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
